import { StockRow } from '../types';
import { convertCurrency } from './convertion';

export type AllocationSlice = { label: string; value: number };

export type WalletSummary = {
  /** Dividendos projetados para a carteira atual no ano corrente. */
  dividendStart: number;
  /** Dividendos projetados para a carteira atual no próximo ano. */
  dividendEnd: number;
  paidDividendLastYear: number;
  paidDividend: number;
  goalLastYear: number;
  goalThisYear: number;
  goalNextYear: number;
  /** Valor em reais de cada ativo, do maior para o menor. */
  allocation: AllocationSlice[];
  totalWallet: number;
  /** Variação da carteira nas últimas 24h, em reais. */
  changeWallet: number;
};

/** Soma valor(linha) × quantidade em todas as linhas, arredondado para 2 casas. */
function sumRounded(rows: StockRow[], getValue: (row: StockRow) => number) {
  return parseFloat(rows.reduce((total, row) => total + getValue(row), 0).toFixed(2));
}

export function calculateWalletSummary(rows: StockRow[], brlQuote: number | undefined): WalletSummary {
  const toBrl = (value: number | string | undefined, row: StockRow) =>
    Number(convertCurrency(value, row.currency, brlQuote));

  return {
    dividendStart: sumRounded(rows, (r) => Number(r.start) * Number(r.quantity)),
    dividendEnd: sumRounded(rows, (r) => Number(r.end) * Number(r.quantity)),
    paidDividendLastYear: sumRounded(rows, (r) => Number(r.dividend.lastYear.total) * Number(r.quantity)),
    paidDividend: sumRounded(rows, (r) => Number(r.dividend.thisYear.total) * Number(r.quantity)),
    goalLastYear: sumRounded(rows, (r) => Number(r.dividend.lastYear.total) * Number(r.goal)),
    goalThisYear: sumRounded(rows, (r) => Number(r.start) * Number(r.goal)),
    goalNextYear: sumRounded(rows, (r) => Number(r.end) * Number(r.goal)),
    allocation: rows
      .map((r) => ({ label: r.ticker, value: Number(r.quantity) * toBrl(r.price, r) }))
      .sort((a, b) => b.value - a.value),
    totalWallet: rows.reduce((total, r) => total + Number(r.quantity) * toBrl(r.price, r), 0),
    changeWallet: rows.reduce((total, r) => total + Number(r.quantity) * toBrl(r.change, r), 0),
  };
}
